import { useGetAiAgentProfilesForPortalQuery } from '../../../../__generated__/chirp/com/hubspot/cv/ai/agents/configuration/rpc/AiAgentService.hooks';
export const useHasCustomerAgent = () => {
  var _data$results$length, _data$results;
  const {
    data,
    loading: loadingCustomerAgent
  } = useGetAiAgentProfilesForPortalQuery({
    variables: {
      pageLength: 1
    }
  });
  const hasCustomerAgent = ((_data$results$length = data === null || data === void 0 || (_data$results = data.results) === null || _data$results === void 0 ? void 0 : _data$results.length) !== null && _data$results$length !== void 0 ? _data$results$length : 0) > 0;
  return Boolean(!loadingCustomerAgent && hasCustomerAgent);
};